import { render, staticRenderFns } from "./InviteTemplateSentModal.vue?vue&type=template&id=37f84a61&scoped=true"
import script from "./InviteTemplateSentModal.vue?vue&type=script&lang=js"
export * from "./InviteTemplateSentModal.vue?vue&type=script&lang=js"
import style0 from "./InviteTemplateSentModal.vue?vue&type=style&index=0&id=37f84a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f84a61",
  null
  
)

export default component.exports